import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "min-h-screen",
  "data-theme": "yellow"
}
const _hoisted_2 = { class: "max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = {
  href: '/forum',
  class: "text-sm text-blue-700 hover:text-blue-900 mb-4 inline-block"
}
const _hoisted_4 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6" }
const _hoisted_5 = { class: "text-xl font-bold text-gray-900" }
const _hoisted_6 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_7 = { class: "space-y-4 mb-6" }
const _hoisted_8 = { class: "flex items-start gap-3" }
const _hoisted_9 = { class: "inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-sm font-medium text-blue-800 shrink-0 mt-0.5" }
const _hoisted_10 = { class: "flex-1" }
const _hoisted_11 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 1,
  class: "text-sm font-medium text-gray-900"
}
const _hoisted_14 = { class: "text-xs text-gray-400" }
const _hoisted_15 = {
  key: 2,
  class: "text-xs text-gray-400 italic"
}
const _hoisted_16 = {
  key: 0,
  class: "mb-1 px-3 py-1.5 bg-gray-50 border-l-2 border-blue-300 rounded text-xs text-gray-500"
}
const _hoisted_17 = { class: "font-medium text-gray-700" }
const _hoisted_18 = {
  key: 1,
  class: "flex gap-2"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "text-sm text-gray-700 whitespace-pre-line" }
const _hoisted_21 = {
  key: 3,
  class: "mt-2 flex gap-2"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "text-center text-gray-400 text-sm mb-6"
}
const _hoisted_26 = {
  key: 1,
  class: "bg-white rounded-xl shadow-sm border border-gray-200 p-4"
}
const _hoisted_27 = {
  key: 0,
  class: "mb-2 px-3 py-1.5 bg-gray-50 border-l-2 border-blue-300 rounded text-xs text-gray-500 flex items-center justify-between"
}
const _hoisted_28 = { class: "font-medium text-gray-700" }
const _hoisted_29 = { class: "flex gap-2 items-center mb-2" }
const _hoisted_30 = ["placeholder"]
const _hoisted_31 = { class: "relative" }
const _hoisted_32 = {
  key: 0,
  class: "absolute bottom-full right-0 mb-1 bg-white border border-gray-200 rounded-lg shadow-lg p-2 z-50 w-64 flex flex-wrap gap-1"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  key: 2,
  class: "text-center text-sm text-gray-500"
}
const _hoisted_36 = {
  href: "/users/sign_in",
  class: "text-blue-700 hover:underline"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "forum"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, "← " + _toDisplayString($setup.t('forum.back_to_forum')), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString($props.topic.title), 1 /* TEXT */),
        _createElementVNode("p", _hoisted_6, _toDisplayString($props.topic.user.name) + " · " + _toDisplayString($setup.formatDate($props.topic.created_at)), 1 /* TEXT */)
      ]),
      _createCommentVNode(" Messages "),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.messages, (msg) => {
          return (_openBlock(), _createElementBlock("div", {
            key: msg.id,
            class: "bg-white rounded-xl shadow-sm border border-gray-200 p-4"
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(msg.user.name.charAt(0).toUpperCase()), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  ($props.signedIn && msg.user.id !== $props.userId)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: $event => ($setup.openChatWith(msg.user)),
                        class: "text-sm font-medium text-gray-900 hover:text-blue-700 cursor-pointer"
                      }, _toDisplayString(msg.user.name), 9 /* TEXT, PROPS */, _hoisted_12))
                    : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(msg.user.name), 1 /* TEXT */)),
                  _createElementVNode("span", _hoisted_14, _toDisplayString($setup.formatDateTime(msg.created_at)), 1 /* TEXT */),
                  (msg.updated_at !== msg.created_at)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString($setup.t('forum.edited')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createCommentVNode(" Reply reference "),
                (msg.parent_preview)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(msg.parent_preview.user_name), 1 /* TEXT */),
                      _createTextVNode(": " + _toDisplayString(msg.parent_preview.body), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true),
                _createCommentVNode(" Edit mode "),
                ($setup.editingId === msg.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.editBody) = $event)),
                        type: "text",
                        class: "flex-1 px-3 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $setup.editBody]
                      ]),
                      _createElementVNode("button", {
                        onClick: $event => ($setup.saveEdit(msg)),
                        class: "px-3 py-1.5 text-xs font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800"
                      }, _toDisplayString($setup.t('forum.save')), 9 /* TEXT, PROPS */, _hoisted_19),
                      _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = $event => ($setup.editingId = null)),
                        class: "px-3 py-1.5 text-xs font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200"
                      }, _toDisplayString($setup.t('forum.cancel')), 1 /* TEXT */)
                    ]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createCommentVNode(" Display mode "),
                      _createElementVNode("p", _hoisted_20, _toDisplayString(msg.body), 1 /* TEXT */)
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)),
                _createCommentVNode(" Actions "),
                (!$setup.editingId)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      ($props.signedIn)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: $event => ($setup.startReply(msg)),
                            class: "text-xs text-blue-600 hover:text-blue-800"
                          }, _toDisplayString($setup.t('forum.reply')), 9 /* TEXT, PROPS */, _hoisted_22))
                        : _createCommentVNode("v-if", true),
                      (msg.user.id === $props.userId || $props.userAdmin)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: $event => ($setup.startEdit(msg)),
                            class: "text-xs text-blue-600 hover:text-blue-800"
                          }, _toDisplayString($setup.t('forum.edit')), 9 /* TEXT, PROPS */, _hoisted_23))
                        : _createCommentVNode("v-if", true),
                      (msg.user.id === $props.userId || $props.userAdmin)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            onClick: $event => ($setup.deleteMessage(msg)),
                            class: "text-xs text-red-400 hover:text-red-600"
                          }, _toDisplayString($setup.t('forum.delete')), 9 /* TEXT, PROPS */, _hoisted_24))
                        : _createCommentVNode("v-if", true)
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      ($setup.messages.length === 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString($setup.t('forum.no_messages')), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" New message "),
      ($props.signedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            ($setup.replyTo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("span", null, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString($setup.replyTo.user.name), 1 /* TEXT */),
                    _createTextVNode(": " + _toDisplayString($setup.replyTo.body.substring(0, 80)), 1 /* TEXT */)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = $event => ($setup.replyTo = null)),
                    class: "text-gray-400 hover:text-gray-600 ml-2"
                  }, "×")
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("form", {
              onSubmit: _withModifiers($setup.sendMessage, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_29, [
                _withDirectives(_createElementVNode("input", {
                  ref: "messageInput",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.newMessage) = $event)),
                  type: "text",
                  placeholder: $setup.replyTo ? $setup.t('forum.reply_placeholder') : $setup.t('forum.message_placeholder'),
                  required: "",
                  class: "flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                }, null, 8 /* PROPS */, _hoisted_30), [
                  [_vModelText, $setup.newMessage]
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = $event => ($setup.showEmojis = !$setup.showEmojis)),
                    class: "text-gray-400 hover:text-gray-600 text-xl p-1"
                  }, "😊"),
                  ($setup.showEmojis)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.emojis, (e) => {
                          return _createElementVNode("button", {
                            key: e,
                            type: "button",
                            onClick: $event => ($setup.addEmoji(e)),
                            class: "text-xl hover:bg-gray-100 rounded p-1 cursor-pointer"
                          }, _toDisplayString(e), 9 /* TEXT, PROPS */, _hoisted_33)
                        }), 64 /* STABLE_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("button", {
                  type: "submit",
                  disabled: !$setup.newMessage.trim(),
                  class: "px-4 py-2 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition disabled:opacity-50"
                }, _toDisplayString($setup.t('forum.send')), 9 /* TEXT, PROPS */, _hoisted_34)
              ])
            ], 32 /* NEED_HYDRATION */)
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_35, [
            _createElementVNode("a", _hoisted_36, _toDisplayString($setup.t('auth.sign_in')), 1 /* TEXT */),
            _createTextVNode(" " + _toDisplayString($setup.t('forum.to_write')), 1 /* TEXT */)
          ]))
    ])
  ]))
}